import {
  CabecalhoPopup,
  ContainerBotoesPopup,
  ContainerItemAccordion,
  ContainerLinhaAccordion,
  ContainerOverflow,
  ContainerPopup,
  TituloPopup,
} from "../../../components/Contrato/Padrao/styles";
import { IconeBotao } from "../../selecaoEmpresas/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import { TextoLinha } from "../../contratoCustomizado/cadastro/styles";
import { AccordionSummary, CircularProgress } from "@mui/material";
import { Check } from "phosphor-react";
import {
  BotaoCancelarModal,
  TextoBotaoCancelarModal,
} from "../detalhesPlano/plano/styles";
import { useTheme } from "@emotion/react";
import {
  CabecalhoAccordion,
  ContainerCarregamento,
  ContainerDados,
  LinhaComparacao,
  LinhaItem,
  StyledAccordion,
  TextoCabecalhoAccordionDescricao,
  TypographyTitulo,
} from "./styles";
import GerarModalResponsivo from "../../../components/GerarModalResponsivo";
import Carregando from "../../carregando";
import { BotaoAzulPreenchido } from "../../../components/Botao";
import { useTranslation } from "react-i18next";

export default function ModalDetalharPlano({
  tipoContrato,
  componenteTrigger,
  planosObjeto,
  descricaoNovoPlano,
  fazerPagamento,
  comparacao,
  loadingCalculo = false,
}) {
  const { t } = useTranslation("common");
  const { t: tPagamento } = useTranslation("pagamento");
  const tema = useTheme();

  function ModuloContrato() {
    return planosObjeto?.length === 0 ? (
      <ContainerCarregamento>
        <Carregando />
      </ContainerCarregamento>
    ) : (
      <div>
        {comparacao ? (
          <CabecalhoAccordion>
            <div></div>
            <TextoCabecalhoAccordionDescricao>
              {tPagamento("comparison.currentPlan")}
            </TextoCabecalhoAccordionDescricao>
            <TextoCabecalhoAccordionDescricao>
              {tPagamento("comparison.newPlan", { name: descricaoNovoPlano })}
            </TextoCabecalhoAccordionDescricao>
          </CabecalhoAccordion>
        ) : (
          <CabecalhoAccordion>
            <div></div>
            <TextoCabecalhoAccordionDescricao>
              <div></div>
            </TextoCabecalhoAccordionDescricao>
            <TextoCabecalhoAccordionDescricao>
              {tPagamento("comparison.availability")}
            </TextoCabecalhoAccordionDescricao>
          </CabecalhoAccordion>
        )}
        <StyledAccordion>
          <ContainerLinhaAccordion>
            <ContainerItemAccordion>
              {Object.keys(planosObjeto).map((modulo, index) => (
                <StyledAccordion
                  defaultExpanded
                  key={"itemsContrato" + modulo}
                >
                  <AccordionSummary
                    aria-controls="panel1d-content"
                    id="panel1d-header"
                  >
                    <TypographyTitulo>{modulo}</TypographyTitulo>
                  </AccordionSummary>

                  {planosObjeto[modulo] &&
                    planosObjeto[modulo].map((item, index) => (
                      <LinhaComparacao
                        key={"comparacaoItem" + index + item.nome}
                      >
                        {comparacao ? (
                          <ItemLinha
                            descricao={item.nome}
                            antigo={item.planoAntigoPossui}
                            novo={item.planoNovoPossui}
                            fundoEscuro={index % 2 === 0}
                          />
                        ) : (
                          <ItemLinha
                            descricao={item.descricaoItem}
                            novo={item.inclusoNoPlano}
                            fundoEscuro={index % 2 === 0}
                          />
                        )}
                      </LinhaComparacao>
                    ))}
                </StyledAccordion>
              ))}
            </ContainerItemAccordion>
          </ContainerLinhaAccordion>
        </StyledAccordion>
      </div>
    );
  }
  function IconeStatusPossuiItem({ possuiItem }) {
    return (
      <div style={{ flex: 1, justifyContent: "center", display: "flex" }}>
        {possuiItem ? (
          <Check
            size={22}
            style={{ flex: 1 }}
            weight="bold"
            color="rgba(22, 156, 52, 1)"
          />
        ) : (
          <FontAwesomeIcon
            icon={faX}
            style={{
              flex: 1,
              // marginLeft: 9,
              width: 15,
              height: 15,
              color: `${tema.cores.semanticDanger2}`,
            }}
          />
        )}
      </div>
    );
  }
  function ItemLinha({ descricao, antigo, novo, fundoEscuro }) {
    let corFundo = fundoEscuro
      ? tema.adaptativo("surface3", "neutral10")
      : tema.cores.surface2;

    return (
      <LinhaItem
        style={{
          background: corFundo,
        }}
      >
        <TextoLinha>{descricao}</TextoLinha>
        {comparacao ? <IconeStatusPossuiItem possuiItem={antigo} /> : <div />}
        <IconeStatusPossuiItem possuiItem={novo} />
      </LinhaItem>
    );
  }
  return (
    <GerarModalResponsivo trigger={componenteTrigger} width={750}>
      {(close) => (
        <ContainerPopup>
          <CabecalhoPopup>
            <TituloPopup>
              {comparacao
                ? tPagamento("comparison.contractComparison")
                : tPagamento("comparison.contractDetails")}
            </TituloPopup>
            <IconeBotao onClick={close}>
              <FontAwesomeIcon
                icon={faX}
                style={{
                  width: 20,
                  height: 20,
                  color: tema.cores.semanticDanger2,
                }}
              />
            </IconeBotao>
          </CabecalhoPopup>
          <ContainerOverflow>
            <ContainerDados>
              <ModuloContrato />
            </ContainerDados>
          </ContainerOverflow>
          <ContainerBotoesPopup>
            <BotaoCancelarModal onClick={close}>
              <TextoBotaoCancelarModal>
                {t("buttons.close")}
              </TextoBotaoCancelarModal>
            </BotaoCancelarModal>
            <BotaoAzulPreenchido
              texto={
                tipoContrato !== "consumidor"
                  ? tPagamento("plan.hire")
                  : tPagamento("invoice.pay")
              }
              onClick={fazerPagamento}
              icone={
                loadingCalculo ? (
                  <CircularProgress
                    style={{
                      color: "white",
                      fill: "white",
                    }}
                    size={15}
                  />
                ) : null
              }
            />
          </ContainerBotoesPopup>
        </ContainerPopup>
      )}
    </GerarModalResponsivo>
  );
}
